import fetch from '@/fetch'

// 学术搜索列表获取
export const shrfidSimpleQryListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/shrfid/simpleqry',
    data: params,
    contentType: 'application/json',
    loading: true,
    actionTypeCode: '57',
    actionTypeDesc: '学术搜索列表获取',
  })
}

// 学术搜索馆藏列表获取
export const shrfidSelectItemListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/shrfidholdings',
    data: params,
    loading: true,
    actionTypeCode: '58',
    actionTypeDesc: '学术搜索馆藏列表获取',
  })
}

// 读者图书预约资格验证
export const shrfidRequestValidGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/shrfidrequestvalid',
    data: params,
    loading: true,
    actionTypeCode: '59',
    actionTypeDesc: '读者图书预约资格验证',
  })
}

// 图书读者预约提交
export const shrfidAddRequest = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/shrfidaddrequest',
    data: params,
    loading: true,
    actionTypeCode: '60',
    actionTypeDesc: '图书读者预约提交',
  })
}

// 获取纸质书刊
export const alephBookListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/aleph',
    data: params,
    loading: true,
    actionTypeCode: '13',
    actionTypeDesc: '纸质书刊列表获取',
  })
}

// 获取电子书
export const ebookBookListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/ebook',
    data: params,
    loading: true,
    actionTypeCode: '14',
    actionTypeDesc: '电子书刊列表获取',
  })
}

// 获取非书特藏
export const specialBookListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/special',
    data: params,
    loading: true,
    actionTypeCode: '15',
    actionTypeDesc: '非书特藏列表获取',
  })
}

// 获取馆藏书目明细
export const alephItemDataGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/index/search/itemdata',
    data: params,
    actionTypeCode: '16',
    actionTypeDesc: '馆藏书目明细获取',
  })
}

// 馆藏书目明细预约
export const alephHoldRequest = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/holdrequest',
    data: params,
    loading: true,
    actionTypeCode: '17',
    actionTypeDesc: '馆藏书目明细预约',
  })
}
